import { useTranslation } from "react-i18next"

import { Button, NotificationUtils } from "@synapse-analytics/synapse-ui"

interface CopyUUIDButtonType {
  textToCopy: string
  disabled: boolean
  isModel?: boolean
}

export const CopyUUIDButton = (props: CopyUUIDButtonType): React.ReactElement => {
  const { t } = useTranslation("common")
  const { disabled, textToCopy, isModel } = props
  return (
    <Button
      onClick={(e) => {
        e?.stopPropagation()
        navigator.clipboard.writeText(textToCopy)
        NotificationUtils.toast(t("copyBtn.copiedToCliboard"), { severity: "success" })
      }}
      disabled={disabled}
      variant="secondary"
      size={"regular"}
    >
      {isModel ? t("copyBtn.copyModelId") : t("copyBtn.copyProjectId")}
    </Button>
  )
}
